// src/app/modules/Members/pages/members-table/column-formatters/JoinedDateFormatter.jsx
import React from "react";
import Moment from "moment";

export function JoinedDateFormatter(cellContent, row) {
  if (!row.joined_at) {
    return <span className="sety-tbl-sub">—</span>;
  }

  const joinedDate = Moment(row.joined_at);
  const isRecent = Moment().diff(joinedDate, 'days') <= 7;

  return (
    <div>
      <div style={{ fontWeight: 600, fontSize: 13.5 }}>{joinedDate.format('MMM DD, YYYY')}</div>
      <div className="sety-tbl-sub" style={{ color: isRecent ? 'var(--green)' : undefined }}>
        {joinedDate.fromNow()}
      </div>
    </div>
  );
}
